<template>
<el-row :gutter="24">
    <header class="header2">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <img src="../assets/zf-logo.png" width="30">
        </el-form-item>
        <el-form-item label="">
          <div class="block">
            <span class="demonstration">年份</span>
            <el-date-picker
              v-model="year"
              align="right"
              type="year"
              placeholder="选择年">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="所获奖项">
          <el-select v-model="awardId" placeholder="请输入关键词"
            filterable
            clearable
            :loading="loading" @visible-change="vchange(awardId)" @change="showList(awardId)" @clear="clearSelect">
            <el-option v-for="item in anameOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="">
          <el-cascader
            placeholder="请输入关键词"
            :options="subnameOptions"
            @change="getThisAwardsId"
            :props="props"
            :clearable="true"
            :filterable="true"
            change-on-select
            :disabled="subnameOptions.length == 0"
          ></el-cascader>

        </el-form-item>
        <el-form-item label="企业名称">
          <el-input v-model="formInline.qname" placeholder="请输入企业名称" @keyup.enter.native="onSubmit"></el-input> 
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </header>
    <div class="grid-content bg-purple">
    <h1>{{award.name}}</h1>
    </div>

    <el-table :data="data" border style="width: 100%" >
      <el-table-column prop="year" label="年份"></el-table-column>
      <el-table-column prop="awardsorder" label="排名"></el-table-column>
      <el-table-column prop="qname" label="企业名称"></el-table-column>
      <el-table-column v-if="(this.$route.params.id == 3)" prop="lcode" label="企业代码"></el-table-column>
    </el-table>

  <div class="block">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[countPerPage, 100, 200, 400]"
      :page-size="countPerPage"
      layout="total,sizes, prev, pager, next"
      :total="total">
    </el-pagination>
  </div>


</el-row>
</template>
<script>
function getData(thisObj, queryObj, countPerPage, currentPage, idArr){
  var paramsObj = {   
        params : {
              where: queryObj, 
              countPerPage: countPerPage, 
              currentPage: currentPage,
              idArr: (queryObj.qname == '') ? thisObj.awardSubId : idArr
        }
      };
  thisObj.$http.get('api/search/getcompany', paramsObj).then(
    response => {
        thisObj.tableData = response.body.listArr;
        thisObj.total = response.body.count;
      },
    response => {
        console.log('failed');
    }
  );
};
function getOptionsKey(value, arrObj){
  var key = 0;
  for(var v in arrObj){
    if(arrObj[v].value == value){
      key = v;
    }
  }
  return key;
};

function getAwardsName(id,thisObj){
  if(id.length > 0){
    thisObj.$http.get('api/search/awards_list', {params: {id: id}}).then(
        response => {
          var awardsList = response.body;
          thisObj.awardsNames = '';
          for(var v in awardsList){
            thisObj.awardsNames += ' ' + awardsList[v].name;
          }
        },
        response => {
          console.log('failed');
        }
      )
  }else{
    thisObj.awardsNames = '';
  }
  
}

function getAwardsIdArr(thisObj, id){

}

export default {
  name: 'thisdata',
  data () {
   return {
      award: {},
      data: [],
      anameOptions: [],  //一级奖项列表
      subnameOptions: [],  //二级奖项列表
      qnameList:[],   //企业名称列表
      awardId: '',
      awardSubId: '',
      awardsNames: '',
      loading: false,
      total:0,
      countPerPage: 10,
      currentPage: 1,
      year:'',
      formInline: {
        // awardId: '',
        qname: '',
        year: ''
      },
      idArr:[],
      firstIdArr:[],

      props: {
        value: 'value',
        label: 'label',
        children: 'subs'
      }
    }
  },

  mounted: function(){
        var year = new Date();
        console.log(year.getFullYear());
        this.year = year;
        this.formInline.year = year.getFullYear();
        this.$nextTick(function () {

            this.$http.get('/api/awards/getawardsdetail',{params: {id: this.$route.params.id}}).then(    // 本奖项上级奖项明细
                  response => {
                    console.log(response.body);
                    var d = response.body
                    this.award = d.award;
                    // this.formInline.aname = d.award.name;
                  },
                  response => {
                    console.log('failed');
                  }
                );

            var getListParams = {
                params : {
                      where:{
                          awardId: this.$route.params.id,
                          year: this.formInline.year
                      }, 
                      countPerPage: this.countPerPage, 
                      currentPage: this.currentPage
                }
            };
            this.$http.get('/api/awards/thisdata',getListParams).then(
                    response => {
                          console.log(response.body);
                          this.data = response.body.listArr;
                          this.total = response.body.count;
                    },
                    response => {
                      console.log('failed');
                    }
            ); 
            this.$http.get('/api/search/awards_list').then(
            response => {
              this.anameOptions = response.body.map(item => {
                return { value: item.id, label: item.name };
              });
            },
            response => {
              console.log('failed');
            }
          );         
        });

    },
  watch: {
    year: {
        handler:function(val,oldval){
          console.log(val,oldval);
            if(val != oldval){
              var year = (val=='') ? new Date() : new Date(val);
              this.formInline.year = year.getFullYear();
            }
        },
        deep:true//对象内部的属性监听，也叫深度监听
    },
    formInline: {
      handler: function(val,oldval){
        // this.$router.push({path: 'result', query: this.formInline});
        getData(this, val, this.countPerPage, this.currentPage, this.idArr);
      },
      deep: true
    },
    idArr: {
      handler: function(val,oldval){
        // this.$router.push({path: 'result', query: this.formInline});
        getData(this, this.formInline, this.countPerPage, this.currentPage, val);
      },
      deep: true
    }
  },
  methods: {
    showList (awardId) {  //一级奖项下拉框change方法
      this.idArr = [];
      this.awardSubId = '';
      this.awardId = '';
      this.awardsNames = '';
      if(awardId == ''){
        this.subnameOptions.length = 0;
      }else{
        this.awardSubId = this.awardId = awardId;
        this.idArr.push(awardId);
        this.$http.get('api/search/get_awards_sublist', {params: {preId: awardId}}).then(  //获取下一级奖项   这部分有待二次开发
          response => {
            var sublist = response.body;
            for(var v in sublist){
              if(sublist[v].issub == 0){
                this.idArr.push(sublist[v].id);
              }else{
                this.idArr.push(sublist[v].id);
                this.$http.get('api/search/get_awards_sublist', {params: {preId: sublist[v].id}}).then( //获取下一级奖项
                  response => {
                    var sublist1 = response.body;
                    for(var v in sublist1){
                      this.idArr.push(sublist1[v].id);
                    }
                    this.firstIdArr = this.idArr;
                  }
                )
              }
              
            }

            this.subnameOptions = sublist.map(item => {
              if(item.issub == 0){
                return {label: item.name, value: item.id};
              }else{
                return {label: item.name, value: item.id, subs:[]};
              }
              
            });
          },
          response => {
            console.log('failed');
          }
        )
      }
    },
    vchange (awardId){
      console.log('暂时用不上了此事件');
    },
    hasValue(strKey,arrObj){  //用于表格里某一列是否显示的判断： 该键值里的值如果有值，isvalue = true，否则 isvalue = false
      var hasvalue = false;
      for(var v in arrObj){
        if((arrObj[v][strKey] != '') && (arrObj[v][strKey] != 'undefined') && (arrObj[v][strKey] != null)){
          hasvalue = true;
        }else{
          hasvalue = false;
        }
      }
      return hasvalue;
    },
    clearSelect () {  //一级奖项clear的方法
      this.awardId = '';
      this.awardSubId = '';
      this.idArr = [];
      // this.formInline.awardId = '';
      this.subnameOptions.length = 0;
    },

    handleItemChange(val) {    // active-item-change事件使用，用于change-on-select的值为false  
        console.log('active item:', val);//生成练级奖项菜单
        if(val != 0){
          this.$http.get('api/search/get_awards_sublist', {params: {preId: val}}).then(
            response => {
              var k = getOptionsKey(val, this.subnameOptions);
              var sublist = response.body;
                this.subnameOptions[k].subs = sublist.map(item => {
                  if(item.issub == 0){
                    return {label: item.name, value: item.id};
                  }else{
                    return {label: item.name, value: item.id, subs:[]};
                  } 
                });
            },
            response => {
              console.log('failed');
            }
          )
        }
    },
    getThisAwardsId(val){
      this.tableData = [];
      console.log('active item:', val);//生成练级奖项菜单
      if(val != 0){
        this.$http.get('api/search/get_awards_sublist', {params: {preId: val}}).then(
          response => {
            var k = getOptionsKey(val, this.subnameOptions);
            var sublist = response.body;
            if(sublist.length == 0) return;
              this.subnameOptions[k].subs = sublist.map(item => {
                if(item.issub == 0){
                  return {label: item.name, value: item.id};
                }else{
                  return {label: item.name, value: item.id, subs:[]};
                } 
              });
          },
          response => {
            console.log('failed');
          }
        )
      }    

      this.idArr = val;
      getAwardsName(val, this);
      if(val.length == 0){
        this.idArr = this.firstIdArr;
        this.awardSubId = this.awardId;
      }else{
        this.awardSubId = val[val.length - 1];
      }
    },

    getTopAwardsName(id, obj){  //获取当前一级奖项名称
      var name = '';
      for(var i = 0; i < obj.length; i++){
        if(i+1 == id){
          name = obj[i].label;
        }
      }
      return name;
    },

    onSubmit () {
      if(this.year != ''){
        var year = new Date(this.year);
        this.formInline.year = year.getFullYear();
      }else{
        this.formInline.year = this.year;
      }
      this.$router.push({path: 'result', query: this.formInline});
      var that = this;
      getData(that, this.formInline, this.countPerPage, this.currentPage, this.idArr);
    },
    handleCurrentChange(val) { //当前在第几页
      this.currentPage = val;
      // this.$router.push({path: 'result', query: this.formInline});
      getData(this, this.formInline, this.countPerPage, this.currentPage, this.idArr);
    },

    handleSizeChange(val) {  //每页显示多少条
      this.countPerPage = val;
      // this.$router.push({path: 'result', query: this.formInline});
      getData(this, this.formInline, this.countPerPage, this.currentPage, this.idArr);

    },

  
  }

}



</script>



// WEBPACK FOOTER //
// src/components/Thisdata.vue